import React from 'react';
export default function EditSquare(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "1em", height: "1em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960" },
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M120-120v-720h465l-60 60H180v600h600v-348l60-60v468zm240-240v-170l424-424 168 170-422 424zm508-425-84-84zM420-420h85l253-253-43-42-43-42-252 251zm295-295-43-42zl43 42z" })));
}
